import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { footerStyles, options } from "./mockData";
import { useMemo } from "react";

const MobileFooter = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 681px)");

  const styles = useMemo(() => isMobile ? footerStyles.xs : footerStyles.md, [isMobile])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ...styles.container
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          ...styles.top
        }}
      >
        {options.map(({ icon: Icon, label }, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ...styles.optionContainer
            }}
          >
            <Icon width={isMobile ? "7px" : "15px"} height={isMobile ? "7px" : "15px"} />
            <Typography
              sx={{
                marginTop: "2px",
                ...styles.optionLabel
              }}
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box 
        sx={{
          border: `1px solid ${theme.palette.common.black}`,
          boxSizing: "border-box",
          ...styles.bottom
        }}
      />
    </Box>
  )
};

export default MobileFooter;